<template>
    <v-data-table
        :headers="headers"
        :items="itemsArr"
        :disable-pagination="true"
        :hide-default-footer="true"
        :disable-sort="true"
        :item-key="itemKey"
        class="data-table">

        <template v-slot:item.label="{ item }">
            <v-checkbox v-model="checkItems" :label="item.label" :value="item.label"></v-checkbox>
        </template>
        <template v-for="option in options" v-slot:[`item.${option.label}`]="{ item }">
            <v-select v-model="selItems[item.label][option.label]"
                        :items="option.items"
                        :key="option.label"
                        outlined
                        dense
                        style="height:40px;font-size:12px;width:110%;"
            ></v-select>
        </template>
        
        <!-- <template v-for="option in options"  v-slot:[`item.${option.label}`]="{ item }">
            <v-select 
                v-model="selItems[item.label][option.label]"
                :items="option.items" 
                :key="option.label" 
            ></v-select>
        </template> -->
 
    </v-data-table>       
</template>
  
  <script>
  export default {
    data() {
      return {
 
       
      };
    },
    props: {
        headers: {
            type: Array,
            required: true
        },
        datas: {
            type: Array,
            required: true
        },
        itemKey: {
            type: String,
            required: true,
        },
        selected01: {
            type: Array,
            required: true,
        },
        selected02: {
            type: Object,
            required: true,
        },
        options: {
            type: Array,
            required: true,
        },
        load: {
        type: Boolean,
        required: true
        },
    },
    methods: {
   
    },
    computed: {
        itemsArr() {
            if(this.datas && this.load){
                return this.datas;
            }
            return null;
        },
        selItems(){
            if(this.datas && this.load){
                return this.selected02;
            }
            return null;
        },
        checkItems: {
            get() {
                if(this.datas && this.load){
                    return this.selected01;
                }
                return null;
            },
            set(val){
                return this.$emit('update:selected01', val);
            }
        },
        loading() {
            return this.$store.state.asset.loading;
        }
    },
    mounted() {
        if(this.datas && this.load){
           
        }
    },
  };
  </script>
  
  <style>
.data-table >>> .v-data-table__wrapper table tbody tr td {
    font-size: 13px;
}
.data-table >>> .v-data-footer__pagination {
  margin: 0; 
}
.data-table >>> .v-data-footer__icons-before {
  width: 20px;
}
  </style>
  